// #583: EIN Lader für pdf.js. Bewusst der Legacy-Build: der normale Build von pdfjs-dist 5.x
// ruft u. a. Map.prototype.getOrInsertComputed auf, ohne es nachzurüsten. Das können nur
// die allerneuesten Browser – auf iPhones mit älterem Safari (und älterem Chrome) scheiterte
// page.render, die Signierseite blieb weiß. Der Legacy-Build bringt die Polyfills mit.
// Bitte NICHT auf `import('pdfjs-dist')` zurückstellen.
export async function ladePdfjs() {
  const pdfjs = await import('pdfjs-dist/legacy/build/pdf.mjs');
  pdfjs.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/legacy/build/pdf.worker.min.mjs', import.meta.url).toString();
  return pdfjs;
}
